document.addEventListener('DOMContentLoaded', function() {    
  const viewToggle = document.getElementById('view-toggle');
  const productGrid = document.querySelector('.featured_product.main-collection-product-grid');
  const toggleContainer = document.querySelector('.toggle-container');

  function toggleView(toggle) {
    if (toggle.checked) {
      toggleContainer.classList.add('onbody-view');
      toggleContainer.classList.remove('product-view');
      productGrid.classList.add('onbody-view');
      productGrid.classList.remove('product-view');
      localStorage.setItem('viewToggle', 'onbody');

    } else {
      toggleContainer.classList.add('product-view');
      toggleContainer.classList.remove('onbody-view');
      productGrid.classList.add('product-view');
      productGrid.classList.remove('onbody-view');
      localStorage.setItem('viewToggle', 'product');

    }
  }

  const savedToggleState = localStorage.getItem('viewToggle');
  // console.log('savedToggleState', savedToggleState);
  // console.log('viewToggle initial state', viewToggle.checked);
  
  
  if (savedToggleState === 'onbody') {
    viewToggle.checked = true;
    toggleContainer.classList.add('onbody-view');
    toggleContainer.classList.remove('product-view');
    productGrid.classList.add('onbody-view');
    productGrid.classList.remove('product-view');
  } else {
    viewToggle.checked = false; 
    toggleContainer.classList.add('product-view');
    toggleContainer.classList.remove('onbody-view');

    productGrid.classList.add('product-view');
    productGrid.classList.remove('onbody-view');
  }

  viewToggle.addEventListener('change', function() {
    toggleView(viewToggle);
    // console.log('viewToggle', viewToggle.checked);
    
  });
});